import { Card, CardContent, Grid } from '@material-ui/core'
import {
  components,
  constants,
  useTranslation
} from 'cng-web-lib'

import SubscriptionApiUrls from 'src/apiUrls/SubscriptionApiUrls'
import React from 'react'
import SubscriptionKeys from 'src/constants/locale/key/Subscription'
import Namespace from 'src/constants/locale/Namespace'

const {
  card: { CngSimpleCardHeader },
  table: {
    CngCrudTable,
    useDefaultNotification
  }
} = components

const {
  locale: {
    key: { UiComponentKeys }
  }
} = constants

function TablePage(props) {
  const {
    location: { pathname },
    showNotification
  } = props

  const notification = useDefaultNotification(showNotification)
  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.SUBSCRIPTION
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let subscription = translate(
      Namespace.SUBSCRIPTION,
      SubscriptionKeys.TITLE
    )
    let tableTitle = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Table.TITLE,
      {
        nameTitleised: subscription
      }
    )
    let subscriptionCode = translate(
      Namespace.SUBSCRIPTION,
      SubscriptionKeys.SUBSCRIPTION_CODE
    )
    let subscriptionName = translate(
      Namespace.SUBSCRIPTION,
      SubscriptionKeys.SUBSCRIPTION_NAME
    )
    let subscriptionDescription = translate(
      Namespace.SUBSCRIPTION,
      SubscriptionKeys.SUBSCRIPTION_DESCRIPTION
    )
    let status = translate(
      Namespace.SUBSCRIPTION,
      SubscriptionKeys.STATUS
    )

    return {
      subscription,
      tableTitle,
      subscriptionCode,
      subscriptionName,
      subscriptionDescription,
      status
    }
  }

  const columns = [
    {
      field: "subscriptionCode",
      title: translatedTextsObject.subscriptionCode,
    },
    {
      field: "subscriptionName",
      title: translatedTextsObject.subscriptionName,
    },
    {
      field: "subscriptionDescription",
      title: translatedTextsObject.subscriptionDescription,
    },
    {
      field: "status",
      title: translatedTextsObject.status,
      type: "boolean",
    }
  ]

  return (
    <Card>
      <CngSimpleCardHeader title={translatedTextsObject.tableTitle} />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CngCrudTable
              {...props}
              fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
              addRoute={`${pathname}/add`}
              columns={columns}
              del={{ url: SubscriptionApiUrls.DELETE }}
              editRoute={`${pathname}/edit`}
              exportData={{ url: SubscriptionApiUrls.EXPORT }}
              fetch={{ url: SubscriptionApiUrls.GET }}
              idAccessor="id"
              notification={notification}
              //tableConfigurationCode="REPLACE_WITH_CORE_TABLE_CONFIG_CODE"
              viewRoute={`${pathname}/view`}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default TablePage
